export default __webpack_public_path__ + "static/media/home2@2x.c840a6ff.png";